import {ICar} from "@/modules/Car/interfaces/car.interface";

export namespace CarInfoConfig {
  export const DefaultFormModel: ICar.IEntity = {
    balance: null,
    carId: null,
    carStatusId: ICar.CarStatusId.Active,
    comment: '',
    corpId: null,
    corpName: '',
    dateBeg: '',
    dateEnd: '',
    parks: [],
    custId: null,
    dateIn: '',
    dateOut: '',
    dayInMonth: null,
    carNumber: '',
    additionalCarNumber: '',
    timeHour: null,
    timeMinute: null,
    guestFlag: false,
    model: '',
    persName: '',
    email: '',
    phone: '',
    tmPersonId: null,
    tarifId: null,
    dateBegTarif: '',
    payGuestHours: null,
    nonStandartFlag: false,
    carTypeId: null,
    disableCancelMovsFlag: false,
    freeSaldoFlag: false,
    disableLevenshteinFlag: false,
  };
}